import { render, staticRenderFns } from "./TemplateProductSpecsModal.vue?vue&type=template&id=f00bd86e&scoped=true"
import script from "./TemplateProductSpecsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TemplateProductSpecsModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TemplateProductSpecsModal.vue?vue&type=style&index=0&id=f00bd86e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00bd86e",
  null
  
)

export default component.exports